export default {
  dev: ENVIRONMENT === 'development',
  donationRoot: 'https://donate.bitfeed.live',
  debug: false,
  donationsEnabled: true,
  messagesEnabled: true,
  alertDuration: 20000,
}
